module.exports = __webpack_public_path__ + "img/forest-pro.66445735.jpg";